import { render } from "./TheCartPage.vue?vue&type=template&id=592c79a4"
import script from "./TheCartPage.vue?vue&type=script&lang=js"
export * from "./TheCartPage.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__